/* Carrito lateral Villaplus: agregar recomendado, cambiar talla y cupón. Se delega en document porque Dawn repinta todo el
   contenido del carrito en cada cambio (los listeners directos se perderían).
   Para repintar se reutiliza CartDrawer.renderContents() de Dawn. */
(function () {
  var SECCIONES = 'cart-drawer,cart-icon-bubble';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function post(url, body) {
    body.sections = SECCIONES;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status) throw json;
        return json;
      });
    });
  }

  function repintar(json) {
    var d = drawer();
    if (d && json.sections) d.renderContents(json);
    burbuja();
  }

  /* El encabezado de Villaplus usa #vp-cart-icon-bubble (Dawn solo refresca
     #cart-icon-bubble), así que el número del carrito se actualiza aquí. */
  function burbuja() {
    var link = document.getElementById('vp-cart-icon-bubble');
    if (!link) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var b = link.querySelector('.cart-count-bubble');
      if (!c.item_count) { if (b) b.remove(); return; }
      if (!b) {
        b = document.createElement('div');
        b.className = 'cart-count-bubble';
        link.appendChild(b);
      }
      b.innerHTML = '<span aria-hidden="true">' + (c.item_count < 100 ? c.item_count : '') + '</span>';
    });
  }
  window.VPCarrito = { burbuja: burbuja };

  /* Agregar un producto recomendado (del carrito) o de "También te puede
     gustar" (ficha de producto). En el segundo caso, sin talla fija: se lee
     del <select> que va justo al lado del botón. */
  function agregar(btn) {
    var idAttr = btn.getAttribute('data-vp-rec-add');
    var id;
    if (idAttr) {
      id = parseInt(idAttr, 10);
    } else {
      var select = btn.parentElement && btn.parentElement.querySelector('[data-vp-rel-size]');
      id = select && parseInt(select.value, 10);
    }
    if (!id) return;
    var tieneTexto = btn.textContent.trim() !== '';
    btn.disabled = true;
    if (tieneTexto) btn.textContent = 'Agregando…';
    post('/cart/add.js', { id: id, quantity: 1 })
      .then(repintar)
      .catch(function () {
        btn.disabled = false;
        if (tieneTexto) {
          btn.textContent = 'Sin stock';
        } else {
          btn.setAttribute('title', 'Sin stock disponible para esa talla');
        }
      });
  }

  /* Cambiar talla: una sola llamada quita la variante vieja y pone la nueva */
  function cambiarTalla(select) {
    var actual = select.getAttribute('data-current');
    var nueva = select.value;
    var qty = parseInt(select.getAttribute('data-qty'), 10) || 1;
    if (actual === nueva) return;
    var updates = {};
    updates[actual] = 0;
    updates[nueva] = qty;
    select.disabled = true;
    post('/cart/update.js', { updates: updates })
      .then(function (json) { json.id = nueva; repintar(json); })
      .catch(function () {
        select.value = actual;
        select.disabled = false;
      });
  }

  /* Cupón: /discount/CODIGO guarda el código y Shopify lo aplica al pagar.
     No se puede validar aquí, por eso el mensaje lo dice tal cual. */
  function cupon(btn) {
    var box = btn.closest('.vp-cart-coupon');
    var input = box.querySelector('[data-vp-coupon-input]');
    var msg = box.querySelector('[data-vp-coupon-msg]');
    var code = input.value.trim();
    if (!code) return;
    btn.disabled = true;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        msg.textContent = 'Código “' + code + '” guardado. Se aplica al pagar si es válido.';
      })
      .catch(function () {
        msg.textContent = 'No se pudo guardar el código. Inténtalo de nuevo.';
      })
      .finally(function () { btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var enlace = e.target.closest('a[href="/cart"], #vp-cart-icon-bubble');
    if (enlace && !e.metaKey && !e.ctrlKey && !e.shiftKey && !document.querySelector('cart-items')) {
      var d = drawer();
      if (d && typeof d.open === 'function') {
        e.preventDefault();
        return d.open(enlace);
      }
    }
    var rec = e.target.closest('[data-vp-rec-add]');
    if (rec) return agregar(rec);
    var rel = e.target.closest('[data-vp-rel-add]');
    if (rel) return agregar(rel);
    var cup = e.target.closest('[data-vp-coupon-apply]');
    if (cup) return cupon(cup);
    var nav = e.target.closest('[data-vp-rec-nav]');
    if (nav) {
      var list = nav.closest('.vp-cart-rec').querySelector('[data-vp-rec-list]');
      list.scrollBy({ left: parseInt(nav.getAttribute('data-vp-rec-nav'), 10) * list.clientWidth * 0.8, behavior: 'smooth' });
    }
  });

  /* Botón de carrito de las tarjetas de la tienda: agrega sin salir de la página */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('.vp-collection-shop__card-form') : null;
    if (!f || !drawer()) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    if (btn) btn.disabled = true;
    post('/cart/add.js', { id: parseInt(f.querySelector('[name="id"]').value, 10), quantity: 1 })
      .then(repintar)
      .catch(function () { if (btn) btn.title = 'Sin stock'; })
      .then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, burbuja);
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-vp-size-select]')) cambiarTalla(e.target);
  });
})();
